// Aolina : les titres des cartes produit tiennent sur 2 lignes au maximum.
// Un titre trop long est légèrement réduit (jamais coupé), jusqu'à une taille plancher.
const SELECTOR = '.product-card .text-block > :is(h2, h3)';
const MIN_SIZE = 11.5;
const STEP = 0.5;

function fit(title) {
  title.style.fontSize = '';
  const styles = getComputedStyle(title);
  let size = parseFloat(styles.fontSize);
  const ratio = parseFloat(styles.lineHeight) / size || 1.25;
  let guard = 20;

  while (guard-- > 0 && size > MIN_SIZE && title.getBoundingClientRect().height > size * ratio * 2 + 1) {
    size -= STEP;
    title.style.fontSize = `${size}px`;
  }
}

function fitAll() {
  document.querySelectorAll(SELECTOR).forEach(fit);
}

if (!window.aoCardTitles) {
  window.aoCardTitles = fitAll;

  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitAll);
  };

  fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  window.addEventListener('load', schedule);

  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    schedule();
  });

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 && (node.matches('.product-card') || node.querySelector('.product-card'))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
